// extracted by mini-css-extract-plugin
module.exports = {"id":"ViewCompanyUserModal_id__2_4nM","submitButton":"ViewCompanyUserModal_submitButton__2kLw5"};